import { clearAuthErrors } from "../store/auth/actionCreators";
import { Dispatch } from "react";

type Path = string;
type IDispatch = Dispatch<any>;

const UseClosePopUpHandler = (path: Path, dispatch: IDispatch) => {
  dispatch(clearAuthErrors({}));

  window.parent.postMessage("closePopUp", path);
};

export default UseClosePopUpHandler;
